<template>
  <div class="ceping">
    <div class="main">
      <h5>工作地点</h5>
      <label v-for="item in chooseradio1" class="choose-radio">
        <input name="item.type" type="radio" @click="choose1(item.name)" />
        {{item.name}}
      </label>

      <h5>学历情况</h5>
      <label v-for="item in chooseradio2" class="choose-radio">
        <input name="item.xueli" type="radio" @click="choose2(item.name)" />
        {{item.name}}
      </label>
      <h5>毕业时间</h5>
      <div class="bixu">
        <input type="text" @change="input1(input1text)" v-model="input1text" />
        <span class="red">*</span>
      </div>
      <h5>已获证书</h5>
      <label v-for="item in chooseradio3" class="choose-radio">
        <input name="item.level" type="radio" @click="choose3(item.name)" />
        {{item.name}}
      </label>
      <h5>工作年限</h5>
      <label v-for="item in chooseradio4" class="choose-radio">
        <input name="item.age" type="radio" @click="choose4(item.name)" />
        {{item.name}}
      </label>
      <h5>联系方式</h5>
      <div class="bixu">
        <input type="text" @change="input2(input2text)" v-model="input2text" />
        <span class="red">*</span>
      </div>
      <!--<h4>测评结果仅表示是否具有参加职称评审资格</h4>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "ceping",
  data() {
    return {
      chooseradio1: [
        { choose: false, name: "杭州", type: "address" },
        { choose: false, name: "宁波", type: "address" },
        { choose: false, name: "温州", type: "address" },
        { choose: false, name: "嘉兴", type: "address" },
        { choose: false, name: "衢州", type: "address" },
        { choose: false, name: "其他", type: "address" }
      ],
      chooseradio2: [
        { choose: false, name: "中专或大专", type: "xueli" },
        { choose: false, name: "本科", type: "xueli" },
        { choose: false, name: "硕士及以上", type: "xueli" },
        { choose: false, name: "其他", type: "xueli" }
      ],
      chooseradio3: [
        { choose: false, name: "初级工程师", type: "level" },
        { choose: false, name: "中级工程师", type: "level" },
        { choose: false, name: "高级工程师", type: "level" },
        { choose: false, name: "无" }
      ],
      chooseradio4: [
        { choose: false, name: "3年以下", type: "age" },
        { choose: false, name: "4-7年", type: "age" },
        { choose: false, name: "7年以上", type: "age" }
      ],
      chooseradio5: [
        { choose: false, name: "基本不对应", type: "right" },
        { choose: false, name: "大部分对应", type: "right" },
        { choose: false, name: "完全对应", type: "right" }
      ],
      input1text: "",
      input2text: "",
      changeData: {
        select1: "",
        select2: "",
        select3: "",
        select4: "",
        input1text: "",
        input2text: ""
      }
    };
  },
  watch: {},
  mounted() {},
  methods: {
    choose1(val) {
      this.changeData.select1 = val;
    },
    choose2(val) {
      this.changeData.select2 = val;
    },
    choose3(val) {
      this.changeData.select3 = val;
    },
    choose4(val) {
      this.changeData.select4 = val;
    },
    input1(val) {
      this.changeData.input1text = val;
    },
    input2(val) {
      this.changeData.input2text = val;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  text-align: center;
}
h5 {
  margin-top: 10px;
}
.choose-radio {
  margin: 0 5px;
}
.bixu {
  display: flex;
  justify-content: space-between;
}
.bixu input {
  width: 95%;
}
.red {
  color: red;
}
.tijiao {
  width: 40%;
  color: #fff;
  text-align: center;
  font-size: 18px;
  background-color: red;
  height: 40px;
  line-height: 40px;
  margin: 20px 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/public/ceping.vue